import $ from 'jquery';
import popover from 'bootstrap/js/dist/popover';

$(document).ready(function () {
  $('[data-toggle="popover"]').popover({
    trigger: 'hover'
  });
  
});